import React, { useState, useEffect, useRef } from 'react';
import './index.css';

const useCountUp = (end, duration = 2000, startOnView = true) => {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!startOnView) { setStarted(true); return; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setStarted(true);
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [startOnView]);

  useEffect(() => {
    if (!started) return;
    const num = parseInt(end, 10);
    if (isNaN(num)) { setCount(end); return; }
    let start = 0;
    const step = Math.ceil(num / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= num) { setCount(num); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [started, end, duration]);

  return { count, ref };
};

const StatItem = ({ stat }) => {
  const { count, ref } = useCountUp(stat.value);
  return (
    <div className="rc-stats__item" ref={ref}>
      <div className="rc-stats__number">
        {count}<span className="rc-stats__suffix">{stat.suffix}</span>
      </div>
      <div className="rc-stats__divider" />
      <div className="rc-stats__label">{stat.label}</div>
    </div>
  );
};

const RoyalStats = ({ config }) => {
  const stats = Array.isArray(config.stats?.items) ? config.stats.items : [];
  if (stats.length === 0) return null;

  return (
    <section id="stats" className="rc-stats">
      <div className="rc-stats__bg-pattern" />
      <div className="container">
        <div className="rc-stats__grid">
          {stats.map((stat, idx) => (
            <StatItem key={idx} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
};

const StatsSection = (props) => {
  const type = (props.config.templateType || 'template1').toLowerCase().replace(/-/g, '_');
  
  switch (type) {
    case 'template11':
    case 'royal_confections':
      return <RoyalStats {...props} />;
    default:
      return null;
  }
};

export default StatsSection;
